import React from 'react';
import { Redirect } from 'react-router-dom';
import { checkPermission, Constants } from 'utils';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';

const Reports = () => {
	const user = useSelector((state: RootState) => state.user);

	if (user?.level_id == Constants.LEVELS.CLIENT || user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) {
		if (checkPermission(Constants.MODULES.DOCUMENTS,'read'))
			return <Redirect to="/client/documents/report" />
	}
	else if (user?.level_id == Constants.LEVELS.ADMIN || user?.level_id == Constants.LEVELS.MODERATOR) {
		if (checkPermission(Constants.MODULES.ADMIN_DOCUMENTS,'read'))
			return <Redirect to="/admin/documents/report" />
	}
}

export default Reports;